<style lang="scss" scoped>
.el-menu-item {
	display: flex;
	justify-content: center;
	align-items: center;
	color: rgb(191, 203, 217);
	background-color: rgb(48, 65, 86);
	&.active {
		background: #fff;
		color: #409eff;
	}
}
</style>
<template>
	<div v-if="!item.hidden">
		<template>
			<li
				class="el-menu-item"
				@click="click2(item)"
				:class="{ active: leftSelect == item.path }"
			>
				<item
					:icon="item.meta.icon || (item.meta && item.meta.icon)"
					:title="generateTitle(item.meta.title)"
				/>
			</li>
		</template>
		<!-- <template
      v-if="
        hasOneShowingChild(item.children, item) &&
        (!onlyOneChild.children || onlyOneChild.noShowingChildren) &&
        !item.alwaysShow &&
        item.dev
      "
    >
      <li
        class="el-menu-item"
        @click="click"
        style="color: rgb(191, 203, 217); background-color: rgb(48, 65, 86)"
      >
        <item
          :icon="onlyOneChild.meta.icon || (item.meta && item.meta.icon)"
          :title="generateTitle(onlyOneChild.meta.title)"
        />
      </li>
    </template> -->
		<!-- <template v-else>
      <li
        class="el-menu-item"
        @click="click2(item)"
        style="color: rgb(191, 203, 217); background-color: rgb(48, 65, 86)"
      >
        <item
          :icon="onlyOneChild.meta.icon || (item.meta && item.meta.icon)"
          :title="generateTitle(onlyOneChild.meta.title)"
        />
      </li>
    </template> -->
	</div>
</template>

<script>
import path from 'path'
import { generateTitle } from '@/utils/i18n'
import { isExternal } from '@/utils/validate'
import Item from './Item'
// import AppLink from "./Link";
import FixiOSBug from './FixiOSBug'

export default {
	name: 'SidebarItem',
	components: {
		Item
		// AppLink
	},
	mixins: [FixiOSBug],
	props: {
		// route object
		item: {
			type: Object,
			required: true
		},
		isNest: {
			type: Boolean,
			default: false
		},
		basePath: {
			type: String,
			default: ''
		},
		leftSelect: {
			type: String,
			default: ''
		}
	},
	data () {
		// To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
		// TODO: refactor with render function
		this.onlyOneChild = null
		return {}
	},
	methods: {
		click () {
			this.$message('暂未开通此服务,敬请期待')
		},
		click2 (item) {
			this.$emit('click', item)
		},
		hasOneShowingChild (children = [], parent) {
			const showingChildren = children.filter((item) => {
				if (item.hidden) {
					return false
				} else {
					// Temp set(will be used if only has one showing child)
					this.onlyOneChild = item
					return true
				}
			})

			// When there is only one child router, the child router is displayed by default
			if (showingChildren.length === 1) {
				return true
			}

			// Show parent if there are no child router to display
			if (showingChildren.length === 0) {
				this.onlyOneChild = { ...parent, path: '', noShowingChildren: true }
				return true
			}

			return false
		},
		resolvePath (routePath) {
			if (isExternal(routePath)) {
				return routePath
			}
			if (isExternal(this.basePath)) {
				return this.basePath
			}
			return path.resolve(this.basePath, routePath)
		},

		generateTitle
	}
}
</script>
